import BossModel from "@/models/BossModel";
import Dossier from "@/models/Dossier/Dossier";
import Traveller from "@/models/Dossier/Traveller/Traveller";
import PnrCode from "@/models/Dossier/Ticket/PnrCode/PnrCode";
import Flight from "@/models/Dossier/Ticket/Flight/Flight";
import DossierTicketDossierTicketFlight from "@/models/Dossier/Ticket/DossierTicketDossierTicketFlight";
import History from "@/models/Dossier/Ticket/History/History";
import ProposalTicket from "@/models/Proposal/Ticket/Ticket";
import User from "@/models/User/User";

export default class Ticket extends BossModel {

    static apiUrl = 'dossier/ticket';

    static entity = 'dossierTickets';

    static fields() {
        return {
            id: this.number(null).nullable(),
            dossier_id: this.number(null).nullable(),
            dossier_traveller_id: this.number(null).nullable(),
            traveller_name: this.attr(null),
            dossier_ticket_pnr_code_id: this.number(null).nullable(),
            start_date: this.attr(null),
            end_date: this.attr(null),
            purchase_price: this.attr(null),
            purchase_tax: this.attr(null),
            sale_price: this.attr(null),
            sale_tax: this.attr(null),
            print_at: this.attr(null),
            printed_at: this.attr(null),
            printed_by_user_id: this.number(null).nullable(),
            unprinted_at: this.attr(null),
            unprinted_by_user_id: this.number(null).nullable(),
            sabre_quote: this.attr(null),
            seat_number: this.attr(null),
            reservation_code: this.attr(null),
            digi_e_ticket_content: this.attr(null),
            emd: this.attr(null),
            ticket_number: this.attr(null),
            text_intern: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            dossier: this.belongsTo(Dossier, 'dossier_id'),
            printed_by_user: this.belongsTo(User, 'printed_by_user_id'),
            unprinted_by_user: this.belongsTo(User, 'unprinted_by_user_id'),
            traveller: this.belongsTo(Traveller, 'dossier_traveller_id'),
            pnrCode: this.belongsTo(PnrCode, 'dossier_ticket_pnr_code_id'),
            flights: this.belongsToMany(Flight, DossierTicketDossierTicketFlight, 'dossier_ticket_id', 'dossier_ticket_flight_id'),
            histories: this.hasMany(History, 'dossier_ticket_id'),
            proposalTickets: this.hasMany(ProposalTicket, 'dossier_ticket_id'),
        }
    }

    static convertQuoteToPrices(quote) {
        return Dossier.api()
            .action('pnr/quote-pricing')
            .create({ticket_quote: quote}, false);
    }

    unPrint() {
        return this.constructor.api()
            .action(this.id + '/un-print')
            .update(this);
    }

    print() {
        return this.constructor.api()
            .action(this.id + '/print')
            .update(this);
    }

    updateFlights(flights = []) {
        return this.constructor.api()
            .action(this.id + '/flights')
            .beforeInsert(() => {
                this.constructor.query().with('flights').find(this.id).flights.forEach(flight => {
                    flight.pivot.$delete();
                });
            })
            .update({flights: flights});
    }
}
